// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2bXDY","item":"PaymentsMobile_item__q0DMC","label":"PaymentsMobile_label__19SCo","amount":"PaymentsMobile_amount__npVMG"};